import { Navigate } from "react-router-dom";

const PrivateRouteProperty = ({ children }) => {
    const token = localStorage.getItem("PropertyAuthToken");
    const authType = localStorage.getItem("authType");
    return token && authType === "property" ? children : <Navigate to="/Property/Login" />;
};

export default PrivateRouteProperty;
